function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 11.95,
    y: 17.55,
    width: 1.71,
    height: 1.71,
    style: {
      fill: "#00a8e9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.13,
    y: 17.55,
    width: 1.71,
    height: 1.71,
    style: {
      fill: "#00a8e9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.24,
    y: 17.55,
    width: 1.71,
    height: 1.71,
    style: {
      fill: "#00a8e9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.95,
    y: 20.67,
    width: 1.71,
    height: 1.71,
    style: {
      fill: "#00a8e9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.13,
    y: 20.67,
    width: 1.71,
    height: 1.71,
    style: {
      fill: "#00a8e9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.24,
    y: 20.67,
    width: 1.71,
    height: 1.71,
    style: {
      fill: "#00a8e9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.95,
    y: 23.77,
    width: 1.71,
    height: 1.71,
    style: {
      fill: "#00a8e9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.13,
    y: 23.77,
    width: 1.71,
    height: 1.71,
    style: {
      fill: "#00a8e9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.24,
    y: 23.77,
    width: 1.71,
    height: 1.71,
    style: {
      fill: "#00a8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5,12.65c0-1.8-1.22-3.4-3.45-4.59a15.84,15.84,0,0,0-7-1.56,15.87,15.87,0,0,0-7,1.56C6.75,9.18,5.5,10.85,5.5,12.65h0v1.26a1.06,1.06,0,0,0,1,1.05h4.21a1.07,1.07,0,0,0,1.05-1.05V12.65c0-.55,1-2.22,4.25-2.22s4.26,1.6,4.26,2.22v1.26A1.08,1.08,0,0,0,21.36,15h4.18a1.06,1.06,0,0,0,1-1.05Z",
    style: {
      fill: "#7e7e7e"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDial);
export default __webpack_public_path__ + "static/media/dial.7184f626.svg";
export { ForwardRef as ReactComponent };